var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Box, Divider, Flex, Heading, Icon, MemberTerminationBanner, Spinner, Text, } from 'shared/components';
import { Ellipse } from 'shared/assets/icons';
import { getAgeFromFormattedDob } from 'shared/utils';
import { useMember } from 'shared/hooks';
import { SUDStatus } from 'shared/features/substance-use-disorder';
// AKA Facesheet
// Currently not rendering children but ripping it out seemed to impact too many other things.
export var MemberHeader = function (_a) {
    var _b;
    var children = _a.children, memberId = _a.memberId, prefetchedMember = _a.prefetchedMember;
    if (!memberId)
        return null; // render nothing if we're not ready yet. it's prettier. Failures should be handled gracefully though.
    var disableQuery = !!prefetchedMember;
    var _c = useMember(memberId, disableQuery), data = _c.data, isLoading = _c.isLoading, isError = _c.isError, error = _c.error;
    if (!disableQuery) {
        if (isError) {
            return _jsx("div", { children: error });
        }
        if (isLoading) {
            return (_jsx(Box, { children: _jsx(Spinner, { "data-testid": "loading" }) }));
        }
    }
    var member = prefetchedMember !== null && prefetchedMember !== void 0 ? prefetchedMember : data;
    var age = getAgeFromFormattedDob(member === null || member === void 0 ? void 0 : member.date_of_birth);
    return (_jsxs(_Fragment, { children: [_jsxs(Flex, __assign({ direction: "column", as: "header", position: "sticky", top: 0, w: "100%", bgColor: "white", pt: 4, pr: 0, mb: 3, zIndex: "200" }, { children: [_jsx(MemberTerminationBanner, { terminateAt: (_b = member === null || member === void 0 ? void 0 : member.terminate_at) !== null && _b !== void 0 ? _b : '' }), _jsxs(Flex, __assign({ direction: "row", bgColor: "white" }, { children: [_jsx(Heading, __assign({ size: "h2", "data-testid": "memberHeaderName" }, { children: "".concat(member.first_name, " ").concat(member.last_name) })), _jsx(Icon, { as: Ellipse, boxSize: 7, ml: 4, mt: 3 }), _jsxs(Text, __assign({ size: "body1", mt: 2 }, { children: [member.date_of_birth, " (", age, " yo)"] }))] })), data && _jsx(SUDStatus, { member: data }), _jsx(Divider, { zIndex: "-1" }), _jsx(Box, { boxShadow: '0px 0px 8px 0.25px #482d28', zIndex: "-1", ml: "4px", mr: "4px" })] })), children] }));
};
